import styled from 'styled-components';

export const InfoText = styled.p`
    margin-bottom: 4px;
`;
